/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

import PreventMultipleTabs from './library/preventMultipleTabs';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import Vuex, { mapGetters, mapState } from 'vuex';
import VueRouter from 'vue-router';
import router from './routes';
import store from './store/store';
import axios from 'axios';
import VueMask from 'v-mask';
import VueCookies from 'vue-cookies';
import VueGtm from 'vue-gtm';

window.Vue = require('vue');

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueMask);
Vue.use(VueCookies);
Vue.use(VueGtm, {
  id: process.env.MIX_GOOGLE_TRACKER_ID,
  // queryParams: {
  //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview: 'env-4',
  //   gtm_cookies_win: 'x',
  // },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  // nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (optional)
  trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
});
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_HOST;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
store.dispatch('auth/me').then(() => {
  new Vue({
    router,
    store,
    created() {
      this.$store.dispatch('setProgram', this.$route);
      this.runValidateCallCenterTab();
      setInterval(function () {
        axios.get('/api/refresh-token/').then(({ data }) => {
          window.axios.defaults.headers.common = {
            'X-CSRF-TOKEN': data,
            'X-Requested-With': 'XMLHttpRequest',
          };
        });
      }, 1000 * 60 * 5);
    },
    data() {
      return {
        ...PreventMultipleTabs.data,
      };
    },
    methods: {
      ...PreventMultipleTabs.methods,
    },
  }).$mount('#app');
});
